import axios from "axios";
import { apiCall } from "../ApiResult.model";
import {
  BaseFindingInput,
  BaseMultipleFindingsInput,
  FindingObjectType,
  FindingType,
  FindingsEntity,
} from "./findings.model";
import { ListResult } from "@/common/models";
import { FindingEntityMapper } from "./entities-mapping";

export const get_finding_count = apiCall<
  BaseFindingInput,
  Array<{ labelId: string; count: number }>
>("findings.count", async (input) => {
  console.log(
    "= = = = get_finding_count = = = = ",
    input.service,
    input.application,
    input.type,
    "- - - - "
  );
  const res = await axios.post("/finding/count", {
    serviceId: input.service,
    applicationId: input.application,
    findingType: input.type,
    labelIds: input.label_ids,
    axisW: input.axis_w ? input.axis_w!.type : "None",
    propW: input.axis_w ? input.axis_w!.value : "None",
    axisZ: input.axis_z.type,
    propZ: input.axis_z.value,
  });
  return {
    success: true,
    value: res.data,
  };
});

export const get_finding_counts = apiCall<
  BaseMultipleFindingsInput,
  Array<{ labelId: string; count: number; findingType: FindingType }>
>("findings.count", async (input) => {
  const res = await axios.post("/finding/count", {
    serviceId: input.service,
    applicationId: input.application,
    findingTypes: input.types,
    labelIds: input.label_ids,
    axisW: input.axis_w ? input.axis_w!.type : "None",
    propW: input.axis_w ? input.axis_w!.value : "None",
    axisZ: input.axis_z.type,
    propZ: input.axis_z.value,
  });
  return {
    success: true,
    value: res.data,
  };
});

export const get_finding_entities = (type: FindingObjectType) => {
  const mapper = FindingEntityMapper.by_object_type(type);
  return apiCall<
    BaseFindingInput & { cursor: string },
    ListResult<FindingsEntity>
  >("findings.entities", async (input) => {
    const res = await axios.post("/finding/load", {
      serviceId: input.service,
      applicationId: input.application,
      findingType: input.type,
      labelIds: input.label_ids,
      axisZ: input.axis_z.type,
      propZ: input.axis_z.value,
      axisW: input.axis_w ? input.axis_w!.type : "None",
      propW: input.axis_w ? input.axis_w!.value : "None",
      limit: 100,
      cursor: input.cursor,
    });
    return {
      success: true,
      value: {
        cursor: res.data.cursor,
        objects: res.data.objects.map(mapper),
      },
    };
  });
};

export const search_finding_entities = apiCall<
  BaseFindingInput & { cursor: string },
  ListResult<FindingsEntity>
>("findings.search", async (input) => {
  const res = await axios.post("/finding/search", {
    serviceId: input.service,
    applicationId: input.application,
    findingType: input.type,
    labelIds: input.label_ids,
    limit: 100,
    search: "",
    cursor: input.cursor,
  });
  return {
    success: true,
    value: res.data,
  };
});
